import { render, staticRenderFns } from "./AppFlatBadge.vue?vue&type=template&id=3b839a18&scoped=true&"
import script from "./AppFlatBadge.vue?vue&type=script&lang=js&"
export * from "./AppFlatBadge.vue?vue&type=script&lang=js&"
import style0 from "./AppFlatBadge.vue?vue&type=style&index=0&id=3b839a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b839a18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
